<template>
<div>

<content-component
  :datafile="ar"/>
<v-container fluid>
<core-footer />
</v-container>
</div>
</template>

<script>
import {ar} from '@/data/ar.js'
import 'video.js/dist/video-js.css'
import ContentComponent from "../components/ar";

export default {
  name: 'AR',
  components: {ContentComponent,
  CoreFooter: () => import ('@/components/core/Footer')},
  data: () => ({
    ar
  }),
}
</script>
